import { render, staticRenderFns } from "./MouthRanking2.vue?vue&type=template&id=204cfa12&scoped=true"
import script from "./MouthRanking2.vue?vue&type=script&lang=js"
export * from "./MouthRanking2.vue?vue&type=script&lang=js"
import style0 from "./MouthRanking2.vue?vue&type=style&index=0&id=204cfa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204cfa12",
  null
  
)

export default component.exports